import { useMemo } from "react";
import GaugeComponent from "react-gauge-component";
import { useTheme } from "@reactive-resume/hooks";

type GaugeProps = {
  score: number;
  size?: "small" | "medium" | "large";
  type?: "semicircle" | "radial";
};

export const Gauge = ({ score, size = "medium", type = "semicircle" }: GaugeProps) => {
  const roundedScore = Math.round(score);
  const { isDarkMode } = useTheme();

  const colorArray = isDarkMode
    ? ["#ef5350", "#ffb74d", "#66bb6a"]
    : ["#e57373", "#ffb74d", "#81c784"];

  const labelColor = isDarkMode ? "#e0e0e0" : "#424242";

  const gaugeSize = useMemo(() => {
    switch (size) {
      case "small":
        return { width: "200px", height: "120px" };
      case "large":
        return { width: "300px", height: "180px" };
      case "medium":
      default:
        return { width: "250px", height: "150px" };
    }
  }, [size]);

  return (
    <div className="flex flex-col items-center" style={gaugeSize}>
      <GaugeComponent
        type={type}
        arc={{
          colorArray,
          padding: 0.02,
          subArcs: [
            { limit: 30, showTick: true }, // Red
            { limit: 50, showTick: true }, // Orange
            { limit: 70, showTick: true }, // Amber
            { limit: 85, showTick: true }, // Green
            { limit: 100, showTick: true }, // Dark Green
          ],
          width: 0.2,
        }}
        pointer={{
          type: "arrow",
          elastic: false,
          animate: true,
          color: labelColor,
          animationDuration: 1000,
        }}
        value={roundedScore}
        labels={{
          valueLabel: {
            style: { fill: labelColor },
          },
        }}
      />
    </div>
  );
};
